$(document).ready(function(){
	$('.scene_menu a').click(function(){
		var href= $(this).attr("href");
		var target = $(href == "#" || href == "" ? 'html' : href);
		//var headerHeight = $('#header').height();
		var position = target.offset().top;
	 	$("html, body").animate({scrollTop:position}, 550, "swing");
	    return false;
		
	});	

});


  


$(function(){
  
  var list = $('.scene_list');
  var item = $('.scene_list .scene_item');
  var col_num = 4;
    
  const matchMediaChecker = () => {
	  if (window.matchMedia( "(max-width: 740px)" ).matches) {
	    col_num = 2;
	  } else if (window.matchMedia( "(min-width: 741px) and (max-width: 999px)" ).matches) {
	    col_num = 3;
	  } else {
	    col_num = 4;
	  }
  }

  matchMediaChecker();
  // リサイズ検知
  window.addEventListener('resize', () => {
	matchMediaChecker();
  });

  $('.scene .scene_inner .scene_item .ttl').click(function(){
	  var index = $(this).parents('.scene_list').find('.ttl').index(this);
	  var start = 0;
	  var end = 0;
	  var syou = 0;
	  var amari = 0;
	  
	  syou = Math.floor(index / col_num);
	  amari = index % col_num;
	  
	  start = syou * col_num;
	  end = ((syou + 1) * col_num);
	  if(end > $(this).parents('.scene_list').find('.ttl').length){
		  end = $(this).parents('.scene_list').find('.ttl').length;
	  }
	  $(this).parents('.scene_list').find('.ttl').slice(start,end).not($(this)).each(function(){
		  $(this).parents('.scene_item').removeClass('open');
		  $(this).next().hide();
	  })
	  if($(this).parents('.scene_item').hasClass('open')){
		  $(this).parents('.scene_item').removeClass('open');
		  $(this).next().slideUp(200);
	  }else{
		  $(this).parents('.scene_item').addClass('open');
		  $(this).next().slideDown(200);
	  }
  })
  
});